import { LoadingOverlay, Modal, Switch } from '@mantine/core';
import { CopyIcon } from '@modulz/radix-icons';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Box, Flex } from '..';
import { diagramApi } from '../../api';
import { DiagramI } from '../../types/diagram';
import {
  AlertContainer,
  AlertText,
  LinkContainer,
  LinkText,
  ModalTitle,
  ShareDiagramIcon,
  SwitchLabel,
  AlertIcon,
} from './ShareDiagramForm.styled';

const ShareDiagramForm = ({
  isOpen,
  onClose,
  diagramData,
  setDiagrams,
}: {
  isOpen: boolean;
  onClose: () => void;
  diagramData: DiagramI | undefined;
  setDiagrams?: (diagrams: DiagramI[]) => void;
}) => {
  const [isDiagramPublic, setIsDiagramPublic] = useState(false);
  const [isEnableSubmitLoading, setIsEnableSubmitLoading] = useState(false);

  const handleSwitchChange = async () => {
    setIsEnableSubmitLoading(true);
    if (diagramData) {
      const payload = {
        id: diagramData.id,
        diagram_name: diagramData.diagram_name,
        is_diagram_public: !isDiagramPublic,
      };

      await diagramApi
        .updateDiagram(payload, diagramData.id, '1')
        .then((res) => {
          if (res.status === 200) {
            if (isDiagramPublic) {
              setIsDiagramPublic(false);
            } else {
              setIsDiagramPublic(true);
            }
            if (setDiagrams) {
              setDiagrams(res.data);
            }
            setIsEnableSubmitLoading(false);
          } else {
            console.log('Error creating new diagram');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    if (diagramData) {
      setIsDiagramPublic(diagramData.is_diagram_public);
    }
  }, [diagramData]);

  return (
    <Modal
      opened={isOpen}
      onClose={() => {
        onClose();
        setIsDiagramPublic(isDiagramPublic);
      }}
      styles={{
        title: { textAlign: 'center', width: '100%' },
      }}
      title={<ModalTitle>Share Diagram </ModalTitle>}
      size="lg"
      transition="fade"
      transitionDuration={600}
      transitionTimingFunction="ease"
      centered
      hideCloseButton
      radius="lg"
    >
      <LoadingOverlay
        visible={isEnableSubmitLoading}
        sx={{ borderRadius: '8px' }}
        loaderProps={{
          color: 'violet',
        }}
      />
      <Flex justifyContent="center" alignItems="center" flexDirection="column">
        <ShareDiagramIcon />
      </Flex>
      <Box p="16px">
        <Flex justifyContent="space-between" alignItems="center" mb="24px">
          <SwitchLabel>Allow public sharing:</SwitchLabel>

          <Switch
            checked={isDiagramPublic}
            onChange={handleSwitchChange}
            styles={{
              input: { cursor: 'pointer' },
            }}
            size="xl"
            color="violet"
            onLabel="ON"
            offLabel="OFF"
          />
        </Flex>
        <LinkContainer mt="24px">
          <LinkText>
            {isDiagramPublic
              ? `${window.location.origin}/diagrams/public-view/${diagramData?.id}`
              : 'enable public sharing to share this diagram'}
          </LinkText>

          <CopyIcon
            width={24}
            height={24}
            onClick={() => {
              if (isDiagramPublic) {
                navigator.clipboard.writeText(
                  `${window.location.origin}/diagrams/public-view/${diagramData?.id}`,
                );
                toast.success('Link copied to clipboard');
              }
            }}
            style={{ cursor: 'pointer' }}
          />
        </LinkContainer>
        <AlertContainer mt="16px">
          <AlertIcon />
          <AlertText ml="8px">
            Anyone with this link can view the diagram.
          </AlertText>
        </AlertContainer>
      </Box>
    </Modal>
  );
};

export default ShareDiagramForm;
